'use strict';
import angular from 'angular';
import _ from 'lodash';

angular.module('vendors.ctrls', [])
    .controller('vendorRegistrationController', vendorRegistrationController);


vendorRegistrationController.$inject = ['$scope', '$ioAlert', 'VendorsService', '$state', 'LoginFactory', 'UserLoginFactory', 'InstanceSettings'];

function vendorRegistrationController($scope, $ioAlert, VendorsService, $state, LoginFactory, UserLoginFactory, InstanceSettings) {
    $scope.registerObj = {};

    /*
    *   Handle vendor registration submission
    */
    $scope.vendorRegister = function() {
        VendorsService.createNewVendor($scope.registerObj).then(function(response) {
            if(response.status === "success"){
                LoginFactory.login({email: $scope.registerObj.email, password: $scope.registerObj.password}).success(function (json) {
                    if(json.error === false){
                        $state.go("io_clientDash");
                    }else{
                        $ioAlert.show('Error', 'Error login', 'error');
                    }
                });
            }else{
                _.each(response.data, function(errorMessage){
                    $ioAlert.show('Error', errorMessage, 'error');
                });
            }
        }, function() {
            $ioAlert.show('Error', 'Error creating a new vendor', 'error');
        });
    }

    $scope.gotoLogin = function() {
        UserLoginFactory.setUrl(null);
        console.log(UserLoginFactory.getUrl());
        $state.go("login", {});
    }

    LoginFactory.isLoggedIn(false).then(function(isLoggedIn) {
        if (isLoggedIn) {
            $ioAlert.show('Error', "Please logout and try registration again.", 'error');
            $state.go("orders");
        }
    });
}